export const cleanUrlGetDomain = (url) => {
  if (!url) return ''
  url = url.replace(/(http:\/\/|https:\/\/)/i, '')
  url = url.replace(/(www[\d|\w]*\.)/i, '')
  url = url.replace(/\/$/, '')
  if (url.indexOf('/') !== -1) {
    url = url.substring(0, url.indexOf('/'))
  }
  try {
    var urlObj = new URL('http://' + url)
    if (urlObj.pathname && urlObj.hostname !== urlObj.pathname) {
      url = urlObj.hostname
    }
  } catch (e) {}
  return url
}

export const isEmpty = (value) => {
  // 检查 null 或 undefined
  if (value == null) return true

  // 检查空字符串
  if (typeof value === 'string' && value.trim() === '') return true

  // 检查空数组
  if (Array.isArray(value) && value.length === 0) return true

  // 检查空对象
  if (typeof value === 'object' && Object.keys(value).length === 0 && value.constructor === Object) return true

  return false
}

// 时间戳 转换
export const formatTimestampToMonthYear = (timestamp) => {
  if (timestamp.length == 10) {
    const date = new Date(timestamp * 1000)
    const options = { year: 'numeric', month: 'long' }
    return date.toLocaleDateString('en-US', options).toUpperCase()
  } else {
    return ''
  }
}
// 获取当前年月October 2024
export const getCurrentMonthYear = () => {
  const date = new Date()
  const options = { year: 'numeric', month: 'long' }
  return date.toLocaleDateString('en-US', options)
}
export const formatTimestamp = (timestamp) => {
  if (timestamp.toString().length == 10) {
    const date = new Date(timestamp * 1000)

    const day = date.getDate()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const formattedDate = `${day}-${month}-${year}`
    return formattedDate
  } else {
    return ''
  }
}

export const aliasFormat = () => {
  const path = window.location.pathname
  const pathParts = path.split('/')
  const alias = pathParts[pathParts.length - 1]
  return alias
}

// set seo
export const setSeo = (data) => {
  document.title = data.meta_title ? data.meta_title : 'prcoupon'
  const metaDescription = document.querySelector('meta[name="description"]')
  metaDescription.setAttribute('content', data.meta_desc || 'prcoupon Descript')
  const metaKeywords = document.querySelector('meta[name="keywords"]')
  metaKeywords.setAttribute('content', data.meta_keywords || 'prcoupon.com')
}
